'use client'

import { usePathname } from 'next/navigation'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

/**
 * Renders the global site chrome (mega-menu Header + full Footer) around every
 * page — EXCEPT paid-search landing pages under `/lp/*`, which are single-goal
 * conversion pages that must NOT leak clicks through nav/footer links. Those
 * pages ship their own stripped header + minimal footer from
 * `components/lp/LandingPageTemplate.tsx`. See issue #45 /
 * docs/marketing/google-ads-master-plan.md §3.3.
 *
 * `usePathname()` resolves during SSR, so the server-rendered HTML for an
 * `/lp/*` route already omits the chrome — no flash, no hydration mismatch.
 * `children` stays a Server Component subtree (passed as a prop), so wrapping
 * it here does not force the whole app onto the client.
 */
export default function SiteChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const bare = pathname?.startsWith('/lp/') ?? false

  if (bare) return <main>{children}</main>

  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  )
}
